<template>
  <div>
    <v-container fluid>
      <v-row dense>
        <v-col cols="2">
          <v-autocomplete label="Year end" :items="[2023,2024,2025]" outlined dense hide-details v-model="yearEnd" @change="refresh"/>
        </v-col>

        <v-col class="text-right pr-2">
          <v-tooltip bottom open-delay="1000">
            <template v-slot:activator="{on}">
              <v-btn icon @click="exportCSV" v-on="on"><v-icon>mdi-download</v-icon></v-btn>
            </template>
            Export as CSV file
          </v-tooltip>
        </v-col>
      </v-row>
    </v-container>

    <v-card class="mx-4 pa-4 overflow-y" height="calc(100vh - 180px)">
      <span v-html="report()"/>
    </v-card>
  </div>
</template>

<script>
import {format,add, lastDayOfMonth, isSunday, lastDayOfWeek} from 'date-fns'
import fileSaver from 'file-saver';

export default {
  name: 'ReportsAnnualMovement',
  data() {
    return {
      yearEnd: 2024,
      bcAnnualSummary: null,

      weekly: false,
      monthMenu: false,
      weekMenu: false,
      month: '',
      week: '',
      periodEnd: '',
      storeNumber: 0,
      bcDswr: []
    }
  },
  computed: {
    monthAsDate() {
      return this.$formatDate(this.month+'-01', 'MMMM, yyyy');
    },
    weekAsDate() {
      return this.$formatDate(this.week);
    },
    company() {
      return this.$store.getters.company;
    }
  },
  async created() {
    this.$emit('name', 'Annual Packaged Product Movement Summary')

    this.refresh();
  },
  methods: {
    allowedDates(day) {
      const dp = day.split('-')
      return isSunday(new Date(dp[0],dp[1]-1,dp[2]));
    },
    async refresh() {
      const results = await this.$apiCall(`query ReportsAnnualMovement($yearEnd:Int!) {
                                             bcAnnualSummary(yearEnd:$yearEnd) {
                                               regular {A,A1,A2,B,C,D,E,F,G1,G2,G,H4,H5,H6,H,I,J,K}
                                               refreshment {A,A1,A2,B,C,D,E,F,G1,G2,G,H4,H5,H6,H,I,J,K}
                                             },
                                           }`,
                                           {yearEnd:this.yearEnd});
      if (!results.error)
        this.bcAnnualSummary = results.data.bcAnnualSummary;
    },

    report() {
      if (!this.bcAnnualSummary)
        return '';
      const lines = [`<style>
                @page {size:landscape}
                .report {font-family: Roboto, sans-serif; font-size:12px;width:100%;border-spacing:0;border-collapse:collapse}
                .report .title {font-weight:700;font-size:18px;text-align:left}
                .report .sub-title {text-align:left}
                .report tr {
                  height:25px;
                }
                .report .header {
                  font-weight:bold;
                  text-align: center;
                  background-color: #d0d0d0;
                }
                .report .subheader {
                  font-weight:bold;
                  text-align: center;
                  font-size:120%;
                  background-color: #ffff0d;
                }
                .report td {
                  border: 1px solid #000;
                  padding-left:5px;
                  padding-right:5px;
                }
                .report .data td:not(:first-child) {
                  text-align:right;
                }
                .report .enter {
                  background-color: #8cff88
                }
              </style>
              <table class="report">
                <thead>
                  <tr>
                    <th colspan="5" class="title">Packaged Product Movement Summary</th>
                  </tr>
                  <tr>
                    <th colspan="5" class="sub-title">For the period April 1, ${this.yearEnd-1} - March 31, ${this.yearEnd}</th>
                  </tr>
                  <tr><th colspan="5">&nbsp;</th></tr>
                </thead>
                <tbody>
                  <tr class="header">
                    <td rowspan="2">Type of<br/>Packaged Product</td>
                    <td rowspan="2">Opening Inventory - Packaged Product</td>
                    <td colspan="3">Total Additions</td>
                    <td rowspan="2">Total Packaged Product<br/>Available</td>
                    <td colspan="2">Total Packaged Product<br/>Shipments out of BC</td>
                    <td rowspan="2">Total Packaged Product Available<br/> in BC</td>
                    <td colspan="2">Total Packaged Product Shipments in BC</td>
                    <td rowspan="2">Total Shipments<br/>in BC<br/>(BC Sales)</td>
                    <td colspan="4">Total Packaged Product Deductions</td>
                    <td colspan="2">Closing inventory - Packaged Product</td>
                    <td rowspan="2">Difference</td>
                  </tr>
                  <tr class="header">
                    <td>Total Packaged Production<br/>(Including packaged spirit product transferred from other spirit manufacturers)</td>
                    <td>Packaged Product<br/>Returns</td>
                    <td>Total Net Additions</td>
                    <td>Shipments to<br/>Other Provinces</td>
                    <td>Shipments Out<br/>of Canada</td>
                    <td>Total Shipments to the LDB for LDB Distribution (Warehouse and BCLS)</td>
                    <td>Total Direct Shipments of Packaged Products to MOS</td>
                    <td>LDB Exempted Deductions with Supporting Documents/<br/>Transfer of SKU with Associated Packaged Inventory to Another Licensed Manufacturer</td>
                    <td>Breakage, Defective with Supporting Documents</td>
                    <td>Other<br/>Breakage,<br/>Adjustments,<br/>and Write-Offs Without<br/>Supporting Documents</td>
                    <td>Total Deductions</td>
                    <td>Calculated</td>
                    <td>Physical</td>
                  </tr>

                  <tr class="subheader">
                    <td>Column Reference</td>
                    <td>A</td>
                    <td>1</td>
                    <td>2</td>
                    <td>B&nbsp;=&nbsp;1+2</td>
                    <td>C&nbsp;=&nbsp;A+B</td>
                    <td>D</td>
                    <td>E</td>
                    <td>F&nbsp;=&nbsp;C-D-E</td>
                    <td>G1</td>
                    <td>G2</td>
                    <td>G&nbsp;=&nbsp;G1+G2</td>
                    <td>4</td>
                    <td>5</td>
                    <td>6</td>
                    <td>H&nbsp;=&nbsp;4+5+6</td>
                    <td>I&nbsp;=&nbsp;F-G-H</td>
                    <td>J</td>
                    <td>K&nbsp;=&nbsp;I-J</td>
                  </tr>

                  <tr class="data">
                    <td>Packaged spirits<br/>(other than packaged refreshment beverages)</td>
                    <td class="enter">${this.$number(this.bcAnnualSummary.regular.A,2)}</td>
                    <td class="enter">${this.$number(this.bcAnnualSummary.regular.A1,2)}</td>
                    <td class="enter">${this.$number(this.bcAnnualSummary.regular.A2)}</td>
                    <td>${this.$number(this.bcAnnualSummary.regular.B,2)}</td>
                    <td>${this.$number(this.bcAnnualSummary.regular.C,2)}</td>
                    <td class="enter">${this.$number(this.bcAnnualSummary.regular.D,2)}</td>
                    <td class="enter">${this.$number(this.bcAnnualSummary.regular.E,2)}</td>
                    <td>${this.$number(this.bcAnnualSummary.regular.F,2)}</td>
                    <td class="enter">${this.$number(this.bcAnnualSummary.regular.G1,2)}</td>
                    <td class="enter">${this.$number(this.bcAnnualSummary.regular.G2,2)}</td>
                    <td>${this.$number(this.bcAnnualSummary.regular.G,2)}</td>
                    <td class="enter">${this.$number(this.bcAnnualSummary.regular.H4,2)}</td>
                    <td class="enter">${this.$number(this.bcAnnualSummary.regular.H5,2)}</td>
                    <td class="enter">${this.$number(this.bcAnnualSummary.regular.H6,2)}</td>
                    <td>${this.$number(this.bcAnnualSummary.regular.H,2)}</td>
                    <td>${this.$number(this.bcAnnualSummary.regular.I,2)}</td>
                    <td class="enter">${this.$number(this.bcAnnualSummary.regular.J,2)}</td>
                    <td>${this.$number(this.bcAnnualSummary.regular.K,2)}</td>
                  </tr>

                  <tr class="data">
                    <td>Packaged refreshment beverages</td>
                    <td class="enter">${this.$number(this.bcAnnualSummary.refreshment.A,2)}</td>
                    <td class="enter">${this.$number(this.bcAnnualSummary.refreshment.A1,2)}</td>
                    <td class="enter">${this.$number(this.bcAnnualSummary.refreshment.A2,2)}</td>
                    <td>${this.$number(this.bcAnnualSummary.refreshment.B,2)}</td>
                    <td>${this.$number(this.bcAnnualSummary.refreshment.C,2)}</td>
                    <td class="enter">${this.$number(this.bcAnnualSummary.refreshment.D,2)}</td>
                    <td class="enter">${this.$number(this.bcAnnualSummary.refreshment.E,2)}</td>
                    <td>${this.$number(this.bcAnnualSummary.refreshment.F,2)}</td>
                    <td class="enter">${this.$number(this.bcAnnualSummary.refreshment.G1,2)}</td>
                    <td class="enter">${this.$number(this.bcAnnualSummary.refreshment.G2,2)}</td>
                    <td>${this.$number(this.bcAnnualSummary.refreshment.G,2)}</td>
                    <td class="enter">${this.$number(this.bcAnnualSummary.refreshment.H4,2)}</td>
                    <td class="enter">${this.$number(this.bcAnnualSummary.refreshment.H5,2)}</td>
                    <td class="enter">${this.$number(this.bcAnnualSummary.refreshment.H6,2)}</td>
                    <td>${this.$number(this.bcAnnualSummary.refreshment.H,2)}</td>
                    <td>${this.$number(this.bcAnnualSummary.refreshment.I,2)}</td>
                    <td class="enter">${this.$number(this.bcAnnualSummary.refreshment.J,2)}</td>
                    <td>${this.$number(this.bcAnnualSummary.refreshment.K,2)}</td>
                  </tr>

                  `];

      lines.push(`</tbody>
               </table>`);
      return lines.join('');
    },

    exportCSV() {
      const lines = [`"Column Reference","A","1","2","B=1+2","C=A+B","D","E","F=C-D-E","G1","G2","G=G1+G2","4","5","6","H=4+5+6","I=F-G-H","J","K=I-J"`];
      let line = this.bcAnnualSummary.regular;
      lines.push(`"Packaged spirits",${line.A},${line.A1},${line.A2},${line.B},${line.C},${line.D},${line.E},${line.F},${line.G1},${line.G2},${line.G},${line.H4},${line.H5},${line.H6},${line.H},${line.I},${line.J},${line.K}`);
      line = this.bcAnnualSummary.refreshment;
      lines.push(`"Packaged refreshment beverages",${line.A},${line.A1},${line.A2},${line.B},${line.C},${line.D},${line.E},${line.F},${line.G1},${line.G2},${line.G},${line.H4},${line.H5},${line.H6},${line.H},${line.I},${line.J},${line.K}`);

      // Write CSV file
      const blob = new Blob([lines.join('\r\n')], {type: "text/plain;charset=utf-8"});
      fileSaver.saveAs(blob, `Annual Packaged Product Movement Summary ${this.yearEnd}.csv`);
    },
  }
}
</script>